exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-panel {\n  border-color: #ddd;\n}\n.uu5-bricks-panel > .uu5-bricks-panel-header {\n  color: #333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.uu5-bricks-panel > .uu5-bricks-panel-header + .uu5-bricks-panel-body > .uu5-bricks-panel-body-body {\n  border-top-color: #ddd;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/panel.less
// module id = 249
// module chunks = 0